export default __webpack_public_path__ + "static/media/web_semanasanta_coche_330x330_.6e7870f9.png";